import React from 'react';
import { Link } from 'react-router-dom';
import './FormationCard.css';

const FormationCard = ({ formation }) => {
    // Formater le prix en FCFA
    const formatPrix = (prix) => {
        if (!prix || prix === 0 || prix === '0') {
            return 'Gratuit';
        }
        return `${parseInt(prix).toLocaleString('fr-FR')} FCFA`;
    };

    // Déterminer le badge de niveau
    const getNiveauBadge = (niveau) => {
        const badges = {
            'debutant': { label: 'Débutant', color: 'green' },
            'intermediaire': { label: 'Intermédiaire', color: 'orange' },
            'avance': { label: 'Avancé', color: 'red' },
            'tous_niveaux': { label: 'Tous niveaux', color: 'blue' }
        };
        
        return badges[niveau] || { label: 'Non spécifié', color: 'gray' };
    };

    // Obtenir l'icône de type de formation
    const getTypeIcon = (type) => {
        const icons = {
            'presentiel': '📍',
            'ligne': '💻',
            'hybride': '🔄'
        };
        return icons[type] || '📚';
    };

    const niveauBadge = getNiveauBadge(formation.niveau);

    return (
        <div className="formation-card">
            {/* Image de la formation */}
            <div className="formation-card-image">
                {formation.image_url ? (
                    <img src={formation.image_url} alt={formation.titre} />
                ) : (
                    <div className="formation-card-placeholder">
                        <span className="formation-icon">🎓</span>
                    </div>
                )}
                
                {/* Badge niveau */}
                <div className={`formation-badge badge-${niveauBadge.color}`}>
                    {niveauBadge.label}
                </div>
            </div>

            {/* Contenu de la carte */}
            <div className="formation-card-content">
                {/* Titre */}
                <h3 className="formation-card-title">{formation.titre}</h3>

                {/* Description */}
                <p className="formation-card-description">
                    {formation.extrait || formation.description?.substring(0, 120) + '...' || 'Découvrez cette formation complète'}
                </p>

                {/* Informations de la formation */}
                <div className="formation-card-info">
                    {/* Durée */}
                    {formation.duree && (
                        <div className="info-item">
                            <span className="info-icon">⏱️</span>
                            <span className="info-text">{formation.duree}</span>
                        </div>
                    )}

                    {/* Type de formation */}
                    {formation.type_formation && (
                        <div className="info-item">
                            <span className="info-icon">{getTypeIcon(formation.type_formation)}</span>
                            <span className="info-text">
                                {formation.type_formation === 'presentiel' ? 'Présentiel' : 
                                 formation.type_formation === 'ligne' ? 'En ligne' : 
                                 formation.type_formation === 'hybride' ? 'Hybride' : 
                                 formation.type_formation}
                            </span>
                        </div>
                    )}

                    {/* Places disponibles */}
                    {formation.places_disponibles && parseInt(formation.places_disponibles) > 0 && (
                        <div className="info-item">
                            <span className="info-icon">👥</span>
                            <span className="info-text">{formation.places_disponibles} places</span>
                        </div>
                    )}
                </div>

                {/* Prix et CTA */}
                <div className="formation-card-footer">
                    <div className="formation-pricing">
                        {/* Prix particulier */}
                        <div className="prix-particulier">
                            <span className="prix-label">Particulier</span>
                            <span className="prix-montant">
                                {formatPrix(formation.prix_particulier)}
                            </span>
                        </div>

                        {/* Prix entreprise */}
                        {formation.prix_entreprise && parseInt(formation.prix_entreprise) > 0 && (
                            <div className="prix-entreprise">
                                <span className="prix-label">Entreprise</span>
                                <span className="prix-montant">
                                    {formatPrix(formation.prix_entreprise)}
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Bouton Voir détails */}
                    <Link 
                        to={`/formations/${formation.id}`} 
                        className="btn-voir-details"
                    >
                        Voir les détails
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default FormationCard;